import { useEffect, useMemo, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { Accordion, Icon, Icons } from '../../components';
import { ACTIVE_TAB_PARAM, MAX_CARD_WIDTH } from '../../constants';
import { useFeatureFlag } from '../../hooks';
import { IntegrationService, LD_FeatureFlags } from '../../types';
import { conditionalArray, labelToKebabCase } from '../../utils';
import { GongItem } from './GongItem';
import { SalesloftItem } from './SalesloftItem';

const Integrations = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const salesloftFF = useFeatureFlag(LD_FeatureFlags.RELEASE_SALESLOFT_INTEGRATION);

  // Default to invalid tab to prevent the accordion from opening first item by default
  const [initialTab] = useState(() => searchParams.get(ACTIVE_TAB_PARAM) || 'invalid-tab');

  // Clear the tab parameter after reading it
  useEffect(() => {
    if (searchParams.has(ACTIVE_TAB_PARAM)) {
      const newSearchParams = new URLSearchParams(searchParams);
      newSearchParams.delete(ACTIVE_TAB_PARAM);
      setSearchParams(newSearchParams, { replace: true });
    }
  }, [searchParams, setSearchParams]);

  const items = useMemo(
    () => [
      {
        id: labelToKebabCase(IntegrationService.GONG),
        icon: Icon.GONG,
        content: <GongItem />,
      },
      ...conditionalArray(salesloftFF, {
        id: labelToKebabCase(IntegrationService.SALESLOFT),
        icon: Icon.SALESLOFT,
        content: <SalesloftItem />,
      }),
    ],
    [salesloftFF]
  );

  return (
    <div className="display-scrollbar-lg mx-auto h-full w-full overflow-y-auto" style={{ maxWidth: MAX_CARD_WIDTH }}>
      <Accordion
        className="!bg-base-100"
        defaultValue={initialTab}
        items={items.map((item) => ({
          ...item,
          title: '',
          icon: <Icons icon={item.icon} color="text-transparent" preserveSize />,
        }))}
      />
    </div>
  );
};

export default Integrations;
